import { render } from "./login-bgc.vue?vue&type=template&id=2a636b08"
import script from "./login-bgc.vue?vue&type=script&lang=js"
export * from "./login-bgc.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__